import { FormControl, InputLabel, Select } from "@material-ui/core";

export type SelectorOptionType = {
  value: string;
  label: string;
};

type ViewFormControlProps = {
  title: string;
  value: string;
  options: SelectorOptionType[];
};

/**
 * 読み取り専用のセレクターコンポーネントです。
 */
export const ViewOnlySelector: React.FC<ViewFormControlProps> = ({
  title,
  value,
  options,
}) => {
  return (
    <FormControl margin="dense" fullWidth variant="standard">
      <InputLabel>{title}</InputLabel>
      <Select value={value} disabled={true}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
